// removed by extract-text-webpack-plugin
module.exports = {"box":"_3FJB2t70NSl2VKIkJ7mYLV","overlay":"vVdL8ICulTm5ctPW5MCUL","popup":"_24VZeYcXg5GtCWOYlj4CoE","close":"_8Noz_O243G0GwGXkSJlBB","content":"_4RSrCmpxWvqCNFbHWChcQ","popupHeader":"_2DS_wX6BKX95SXWCJnrUkv"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/Popup/Popup.styl
// module id = 744
// module chunks = 0